import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { COLORS, ROUTE_PATHS } from '@constants';
import { Button, Icon, Typography } from '@ui';
import { isIframe } from '@utils';
import { Flex } from 'antd';
import { useCookieConsent } from '../../hooks/useCookieConsent';
import { StyledContent, StyledCookieWrapper } from './styled';

const ConsentNotification = ({ children }) => {
    const { pathname } = useLocation();
    const { showNotification, rejectCookies, acceptCookies } = useCookieConsent();

    const excludedRoutes = [ROUTE_PATHS.CONNECTOR];

    const shouldHide = !showNotification || isIframe() || excludedRoutes.some((route) => pathname.startsWith(route));

    // don't show cookie consent in shopify/bc embedded app
    if (shouldHide) return children;

    return (
        <React.Fragment>
            {children}
            <StyledCookieWrapper>
                <StyledContent data-e2e='consent-notification_block' align='center' gap={24} justify='space-between'>
                    <Flex align='center' gap={10}>
                        <Button
                            data-e2e='consent-notification_close_btn'
                            onClick={() => rejectCookies()}
                            type='noStyle'
                            padding='0'
                            style={{ background: 'transparent' }}
                            icon={
                                <Icon
                                    size='24px'
                                    color={COLORS.$white}
                                    component={() => <Icon.CloseIcon size='24px' />}
                                />
                            }
                        />
                        <Typography.Text data-e2e='consent-notification_description' type='body2' color={COLORS.$white}>
                            This site uses cookies. For more information about cookies and how to disable them, please
                            refer to the{' '}
                            <Link
                                data-e2e='consent-notification_privacy_link'
                                to={ROUTE_PATHS.PRIVACY}
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                site privacy policy
                            </Link>
                            .
                        </Typography.Text>
                    </Flex>
                    <Button
                        data-e2e='consent-notification_got-it_btn'
                        padding='10px 22px'
                        onClick={() => acceptCookies()}
                    >
                        Got It
                    </Button>
                </StyledContent>
            </StyledCookieWrapper>
        </React.Fragment>
    );
};

export default ConsentNotification;
